import { Box, Stack, Typography } from "@mui/material";

import LearnVisualFrame from "./LearnVisualFrame";

const tags = ["Classification", "Lifecycle", "Metallurgy", "Jurisdiction", "Capex", "Project economics"];

export default function ResourceOunceVisual({ title, takeaway, caption, data = {} }) {
  const ev = data.enterpriseValue || "$400M";
  const resource = data.resource || "4 Moz";
  const result = data.result || "$100 / resource oz";

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="compact">
      <Box sx={{ textAlign: "center" }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.4} alignItems="center" justifyContent="center">
          <Box sx={{ minWidth: 180, p: 1.5, border: "1px solid rgba(34,35,37,0.12)", borderRadius: 1, backgroundColor: "#fff" }}>
            <Typography sx={{ fontSize: 12, fontWeight: 850, color: "text.secondary" }}>Enterprise Value</Typography>
            <Typography sx={{ fontSize: 24, fontWeight: 900 }}>{ev}</Typography>
          </Box>
          <Typography sx={{ fontSize: 28, fontWeight: 900, color: "primary.main" }}>{"\u00f7"}</Typography>
          <Box sx={{ minWidth: 180, p: 1.5, border: "1px solid rgba(34,35,37,0.12)", borderRadius: 1, backgroundColor: "#fff" }}>
            <Typography sx={{ fontSize: 12, fontWeight: 850, color: "text.secondary" }}>Reported Resource</Typography>
            <Typography sx={{ fontSize: 24, fontWeight: 900 }}>{resource}</Typography>
          </Box>
          <Typography sx={{ fontSize: 28, fontWeight: 900, color: "primary.main" }}>{"\u2192"}</Typography>
          <Box sx={{ minWidth: 196, p: 1.5, border: "1px solid rgba(201,176,123,0.85)", borderRadius: 1, backgroundColor: "rgba(201,176,123,0.10)" }}>
            <Typography sx={{ fontSize: 12, fontWeight: 850, color: "text.secondary" }}>Comparison Metric</Typography>
            <Typography sx={{ fontSize: 22, fontWeight: 900 }}>{result}</Typography>
          </Box>
        </Stack>

        <Typography sx={{ mt: 2.75, mb: 2.25, fontSize: 20, fontWeight: 900 }}>
          {result} <Box component="span" sx={{ px: 1.25, color: "primary.main" }}>{"\u2260"}</Box> economic value of each ounce
        </Typography>

        <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1} sx={{ mt: 0.5, mb: 0.75 }}>
          {tags.map((tag) => (
            <Box key={tag} sx={{ px: 1.1, py: 0.45, borderRadius: 1, border: "1px solid rgba(34,35,37,0.12)", fontSize: 12, fontWeight: 800, color: "text.secondary", backgroundColor: "rgba(255,255,255,0.72)" }}>
              {tag}
            </Box>
          ))}
        </Stack>
      </Box>
    </LearnVisualFrame>
  );
}
